import Select from 'react-select';
import styled from 'styled-components';

interface Props {
    options: string[] | any[] | undefined;
    name: string;
    value: any[];
    onChange: (name: string, values: any[]) => void;
    isDisabled?: boolean;
    isAutoFocus?: boolean;
    label?: string;
}

const StyledReactSelect = styled(Select)`
    .select__multi-value {
        display: inline-flex;
        align-items: center;
        margin-right: 5px;
    }
    .select__multi-value__remove {
        height: 26px;
        cursor: pointer;
        svg {
            width: 17px;
            height: 17px;
        }
    }
    .select__indicator {
        padding: 6px;
    }
    display: block;
    font-size: .8rem;
    z-index: 2;
    min-width: 200px;
    > div {
        border-radius: 8px;
        background-color: #fff;
    }
    input:focus {
        outline: none !important;
        border: none !important;
        border-bottom: 0 !important;
        box-shadow: none !important;
        background-color: transparent;
    }
`;

const Label = styled.label`
    margin-bottom: 0.2rem;
    font-size: 90%;
`;

const ReactSelect = ({ options, name, onChange, value, isDisabled, isAutoFocus, label } : Props) => {
    let select = null;

    if (options) {
        var values: any[] = [];
        options.forEach(item => {
            if (value.includes(item.value)) {
                values.push(item);
            }
        });

        select =
        <>
            {label ? <Label>{label}</Label> : null}
            <StyledReactSelect
                isMulti
                autoFocus={isAutoFocus}
                className={"basic-single"}
                classNamePrefix="select"
                name={name}
                value={values}
                options={options}
                isDisabled={isDisabled}
                onChange={(values: any) => {
                    var selectedValues: any[] = [];
                    values.forEach((item: any) => {
                        selectedValues.push(item.value);
                    });
                    onChange(name, selectedValues);
                }}
                theme={(theme: any)  => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary25: '#ced4da',
                        primary50: '#ced4da',
                        primary: '#ee7330'
                    }
                })}
            />
        </>
    }

    return select;

};

export default ReactSelect;